import { AxiosResponse } from 'axios'
import { ValidAPIResponse } from 'common/src/api/websiteFrontendVsWebsiteBackend'

export type APIResponseWrapper<T> = Promise<AxiosResponse<ValidAPIResponse<T>>>
export const CB_BASE_UNAUTHENTICATED_PREFIX = '/cb'
export const CB_BASE_PREFIX = '/cb/session'
export const WB_BASE_PREFIX = '/wb/cf'
